var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processo.id
    ? _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { staticClass: "titulo-analise" },
            [
              _c(
                "el-menu",
                {
                  attrs: { "default-active": "1", mode: "horizontal" },
                  on: { select: _vm.handleSelect }
                },
                [
                  _c("el-menu-item", { attrs: { index: "1" } }, [
                    _vm._v(
                      "Emissão do " +
                        _vm._s(_vm.isEstadoMA ? "Boleto" : "DAE") +
                        " " +
                        _vm._s(_vm.processo.numeroProcesso)
                    )
                  ]),
                  _c("el-menu-item", { attrs: { index: "2" } }, [
                    _vm._v("Análise do Processo")
                  ])
                ],
                1
              ),
              _c("app-opcoes-header-analise", {
                attrs: {
                  idProcesso: _vm.processo.id,
                  tipoProcesso: _vm.processo.tipo.codigo,
                  numeroProcesso: _vm.processo.numeroProcesso,
                  protocolo: _vm.processo.numeroProtocolo,
                  btnPendencia: true
                }
              })
            ],
            1
          ),
          _vm.step === 1
            ? [
                _vm.exibirSteps
                  ? _c(
                      "el-steps",
                      {
                        staticClass: "mt-20",
                        attrs: {
                          active: _vm.tela,
                          "finish-status": "success",
                          "align-center": "align-center"
                        }
                      },
                      [
                        _vm.visualizarDae
                          ? _c("el-step", {
                              attrs: {
                                title: _vm.isEstadoMA
                                  ? "Visualizar Boleto(s)"
                                  : "Visualizar DAEs",
                                icon: "el-icon-view",
                                status: _vm.tela > 0 ? "success" : "process"
                              }
                            })
                          : _vm._e(),
                        _c("el-step", {
                          attrs: {
                            title: "Informar dados do documento",
                            status: _vm.tela === 2 ? "success" : "process",
                            icon: "el-icon-edit-outline"
                          }
                        }),
                        _c("el-step", {
                          attrs: {
                            title: "Confirmar dados",
                            status: "process",
                            icon: "el-icon-tickets"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "mb-20",
                          attrs: { type: "flex", gutter: 40 }
                        },
                        [
                          _vm.tela === 0 && !_vm.isEstadoMAOrRR
                            ? _c(
                                "el-col",
                                [
                                  _vm.processo.numeroProcesso
                                    ? _c("app-pagamento", {
                                        attrs: {
                                          numeroProcesso:
                                            _vm.processo.numeroProcesso
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.tela === 0 && _vm.isEstadoMAOrRR
                            ? _c(
                                "el-col",
                                [
                                  _vm.processo.numeroProcesso &&
                                  _vm.isEstadoMAOrRR
                                    ? _c("app-pagamento-ma", {
                                        attrs: {
                                          parcelas: _vm.processo.parcelas
                                        },
                                        on: {
                                          reemitirDae: _vm.reemitirBoleto,
                                          editarDae: _vm.editarDae
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm.isEstadoMAOrRR
                  ? _c("div", [
                      _vm.tela === 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-row",
                                {
                                  staticClass: "mb-40",
                                  attrs: {
                                    type: "flex",
                                    justify: "center",
                                    spaceBetween: "20"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Tipo de Pagamento"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  staticClass:
                                                    "checkbox-group input",
                                                  class: {
                                                    erro: errors.length
                                                  },
                                                  attrs: {
                                                    disabled: _vm.isEdicao
                                                  },
                                                  on: { change: _vm.setRadio },
                                                  model: {
                                                    value: _vm.formaPagamento,
                                                    callback: function($$v) {
                                                      _vm.formaPagamento = $$v
                                                    },
                                                    expression: "formaPagamento"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: {
                                                        label: "A_VISTA"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Pagamento à vista"
                                                      )
                                                    ]
                                                  ),
                                                  !_vm.isRoraima
                                                    ? _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: "PARCELADO"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Pagamento parcelado"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1912260529
                                    )
                                  })
                                ],
                                1
                              ),
                              _c(
                                "validation-observer",
                                { ref: "validation", attrs: { tag: "form" } },
                                [
                                  _vm.dadosInteressado
                                    ? _c(
                                        "form",
                                        {
                                          on: {
                                            submit: function($event) {
                                              $event.preventDefault()
                                              return _vm.onSubmit($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm.isParcelado &&
                                          !_vm.isEdicao &&
                                          !_vm.isRoraima
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "mb-20",
                                                  attrs: {
                                                    type: "flex",
                                                    gutter: 40
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules: "required"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "app-label",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Quantidade de parcelas:",
                                                                          required:
                                                                            "required"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "el-select",
                                                                      {
                                                                        class: {
                                                                          "select select-erro":
                                                                            errors.length
                                                                        },
                                                                        attrs: {
                                                                          placeholder:
                                                                            "Selecione",
                                                                          "value-key":
                                                                            "parcela"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.parcelaSelecionada,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.parcelaSelecionada = $$v
                                                                          },
                                                                          expression:
                                                                            "parcelaSelecionada"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        _vm.parcelas,
                                                                        function(
                                                                          parcela
                                                                        ) {
                                                                          return _c(
                                                                            "el-option",
                                                                            {
                                                                              key: parcela,
                                                                              attrs: {
                                                                                label: parcela,
                                                                                value: parcela
                                                                              }
                                                                            }
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            1401564512
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: { rules: "notZero" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Valor Principal:"
                                                                }
                                                              }),
                                                              _c(
                                                                "app-double-input",
                                                                {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    prefix:
                                                                      "R$ ",
                                                                    propId:
                                                                      "label-valorPrincipal"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.valorPrincipal,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.valorPrincipal = $$v
                                                                    },
                                                                    expression:
                                                                      "valorPrincipal"
                                                                  }
                                                                }
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3198861237
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              !_vm.isParcelado && _vm.isEstadoMA
                                                ? _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules:
                                                              "max_value:100"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "app-label",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Porcentagem de desconto (%):"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "app-double-input",
                                                                      {
                                                                        staticClass:
                                                                          "input",
                                                                        class: {
                                                                          erro:
                                                                            errors.length
                                                                        },
                                                                        attrs: {
                                                                          value:
                                                                            _vm.porcentagemDesconto,
                                                                          suffix:
                                                                            "%",
                                                                          step: 0.01,
                                                                          precision: 2
                                                                        },
                                                                        on: {
                                                                          input:
                                                                            _vm.setPorcentagemDesconto
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            2939759836
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !_vm.isParcelado &&
                                              !_vm.isEstadoRR
                                                ? _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules: "required"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "app-label",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Valor do desconto:"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "app-double-input",
                                                                      {
                                                                        staticClass:
                                                                          "input",
                                                                        class: {
                                                                          erro:
                                                                            errors.length
                                                                        },
                                                                        attrs: {
                                                                          prefix:
                                                                            "R$ ",
                                                                          disable: true
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.valorDesconto,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.valorDesconto = $$v
                                                                          },
                                                                          expression:
                                                                            "valorDesconto"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            230124129
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !_vm.isParcelado
                                                ? _c(
                                                    "el-col",
                                                    [
                                                      _c("app-label", {
                                                        attrs: {
                                                          label:
                                                            "Valor Líquido:"
                                                        }
                                                      }),
                                                      _c("app-double-input", {
                                                        staticClass: "input",
                                                        attrs: {
                                                          value:
                                                            _vm.valorPrincipal -
                                                            _vm.valorDesconto,
                                                          disable: true,
                                                          prefix: "R$ "
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "Data de Emissão:"
                                                    }
                                                  }),
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "el-date-picker",
                                                                {
                                                                  staticClass:
                                                                    "input full-width",
                                                                  attrs: {
                                                                    "picker-options":
                                                                      _vm.options,
                                                                    format:
                                                                      "dd/MM/yyyy",
                                                                    disabled:
                                                                      "disabled"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.dataEmissao,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.dataEmissao = $$v
                                                                    },
                                                                    expression:
                                                                      "dataEmissao"
                                                                  }
                                                                }
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      146981664
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm.isParcelado && !_vm.isRoraima
                                                ? _c(
                                                    "el-col",
                                                    [
                                                      _c("app-label", {
                                                        attrs: {
                                                          label:
                                                            "Data de Vencimento:"
                                                        }
                                                      }),
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules:
                                                              "required|dateAfterToday"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "el-date-picker",
                                                                      {
                                                                        staticClass:
                                                                          "input full-width",
                                                                        attrs: {
                                                                          "picker-options":
                                                                            _vm.options,
                                                                          format:
                                                                            "dd/MM/yyyy",
                                                                          disabled:
                                                                            _vm.isdataVencimetoHabilitada
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.dataVencimento,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.dataVencimento = $$v
                                                                          },
                                                                          expression:
                                                                            "dataVencimento"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            3722063998
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          !_vm.isParcelado && !_vm.isEstadoMA
                                            ? _c(
                                                "el-row",
                                                {
                                                  attrs: {
                                                    type: "flex",
                                                    gutter: 40
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 6 } },
                                                    [
                                                      _c("app-label", {
                                                        attrs: {
                                                          label:
                                                            "Data de Vencimento:"
                                                        }
                                                      }),
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules:
                                                              "required|dateAfterToday"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "el-date-picker",
                                                                      {
                                                                        staticClass:
                                                                          "input full-width",
                                                                        attrs: {
                                                                          "picker-options":
                                                                            _vm.options,
                                                                          format:
                                                                            "dd/MM/yyyy",
                                                                          disabled:
                                                                            _vm.isdataVencimetoHabilitada
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.dataVencimentoPreDefinida,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.dataVencimentoPreDefinida = $$v
                                                                          },
                                                                          expression:
                                                                            "dataVencimentoPreDefinida"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            869347573
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          !_vm.isParcelado && _vm.isEstadoMA
                                            ? _c(
                                                "el-row",
                                                {
                                                  attrs: {
                                                    type: "flex",
                                                    gutter: 40
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 6 } },
                                                    [
                                                      _c("app-label", {
                                                        attrs: {
                                                          label:
                                                            "Data de Vencimento:"
                                                        }
                                                      }),
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules:
                                                              "required|dateAfterToday"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "el-date-picker",
                                                                      {
                                                                        staticClass:
                                                                          "input full-width",
                                                                        attrs: {
                                                                          "picker-options":
                                                                            _vm.options,
                                                                          format:
                                                                            "dd/MM/yyyy",
                                                                          disabled:
                                                                            _vm.isdataVencimetoHabilitada
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.dataVencimento,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.dataVencimento = $$v
                                                                          },
                                                                          expression:
                                                                            "dataVencimento"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            3722063998
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c("app-divider", {
                                            staticClass: "mb-20",
                                            attrs: { label: "" }
                                          }),
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Nome/Razão Social:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value:
                                                        _vm.dadosInteressado
                                                          .nomeRazaoSocial,
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "CPF/CNPJ:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value:
                                                        _vm.dadosInteressado
                                                          .cpfCnpj,
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Número de Processo:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value:
                                                        _vm.processo
                                                          .numeroProcesso,
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Município:"
                                                                }
                                                              }),
                                                              _c("el-input", {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  value: _vm.utilizarMunicipio(),
                                                                  maxlength:
                                                                    "100",
                                                                  disabled:
                                                                    "disabled"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.municipio,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.municipio = $$v
                                                                  },
                                                                  expression:
                                                                    "municipio"
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3585678776
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Endereço:"
                                                                }
                                                              }),
                                                              _c("el-input", {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  value: _vm.utilizarEndereco(),
                                                                  maxlength:
                                                                    "100",
                                                                  disabled:
                                                                    "disabled"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.endereco,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.endereco = $$v
                                                                  },
                                                                  expression:
                                                                    "endereco"
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      1977348138
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Telefone:"
                                                                }
                                                              }),
                                                              _c("el-input", {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  value: _vm.utilizarTelefone(),
                                                                  maxlength:
                                                                    "100",
                                                                  disabled:
                                                                    "disabled"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.telefone,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.telefone = $$v
                                                                  },
                                                                  expression:
                                                                    "telefone"
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      801078437
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm.exibirTabelaParcelas &&
                                          (!_vm.isEstadoMA ||
                                            _vm.dataVencimento)
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticClass: "mb-20",
                                                  attrs: {
                                                    type: "flex",
                                                    gutter: 40
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 8 } },
                                                    [
                                                      _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "el-table",
                                                            {
                                                              staticClass:
                                                                "full-width",
                                                              attrs: {
                                                                data:
                                                                  _vm.parcelasTabela
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "el-table-column",
                                                                {
                                                                  attrs: {
                                                                    prop:
                                                                      "parcela",
                                                                    label:
                                                                      "Parcela"
                                                                  }
                                                                }
                                                              ),
                                                              _c(
                                                                "el-table-column",
                                                                {
                                                                  attrs: {
                                                                    prop:
                                                                      "valor",
                                                                    label:
                                                                      "Valor (R$)"
                                                                  }
                                                                }
                                                              ),
                                                              _c(
                                                                "el-table-column",
                                                                {
                                                                  attrs: {
                                                                    prop:
                                                                      "dataVencimento",
                                                                    label:
                                                                      "Data de vencimento"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tela === 2
                        ? _c(
                            "div",
                            [
                              _c("el-divider", [
                                _c("h3", [_vm._v("Dados do documento")])
                              ]),
                              _c(
                                "el-row",
                                { attrs: { gutter: 40 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c("app-display", {
                                        attrs: {
                                          label: "Nome/Razão Social:",
                                          content:
                                            _vm.dadosInteressado.nomeRazaoSocial
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "CPF/CNPJ:",
                                          content: _vm.dadosInteressado.cpfCnpj
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Endereço:",
                                          content: _vm.endereco
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Município:",
                                          content: _vm.municipio
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c("app-display", {
                                        attrs: {
                                          label: "Telefone:",
                                          content: _vm.telefone
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Nº Processo:",
                                          content: _vm.processo.numeroProcesso
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Data de Emissão:",
                                          content: _vm.formatData(
                                            _vm.dataEmissao
                                          )
                                        }
                                      }),
                                      _vm.isEstadoMA
                                        ? _c("app-display", {
                                            attrs: {
                                              label: "Data de Vencimento:",
                                              content: _vm.formatData(
                                                _vm.dataVencimento
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      !_vm.isEstadoMA
                                        ? _c("app-display", {
                                            attrs: {
                                              label: "Data de Vencimento:",
                                              content: _vm.formatData(
                                                _vm.dataVencimentoPreDefinida
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c("app-display", {
                                        attrs: {
                                          label: "Valor Principal:",
                                          content: _vm.formatValor(
                                            _vm.valorPrincipal
                                          )
                                        }
                                      }),
                                      !_vm.isParcelado && !_vm.isEstadoRR
                                        ? _c("app-display", {
                                            attrs: {
                                              label: "Valor do Desconto:",
                                              content: _vm.formatValor(
                                                _vm.valorDesconto
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.isParcelado && !_vm.isEdicao
                                        ? _c("app-display", {
                                            attrs: {
                                              label: "Valor do juros:",
                                              content: _vm.formatValor(
                                                _vm.valorTotal -
                                                  _vm.valorPrincipal
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      !_vm.isParcelado
                                        ? _c("app-display", {
                                            attrs: {
                                              label: "Valor Total:",
                                              content: _vm.formatValor(
                                                _vm.valorPrincipal -
                                                  _vm.valorDesconto
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.isParcelado &&
                                      !_vm.isEdicao &&
                                      !_vm.isRoraima
                                        ? _c("app-display", {
                                            attrs: {
                                              label: "Valor Total:",
                                              content: _vm.formatValor(
                                                _vm.valorTotal
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.exibirTabelaParcelas
                                ? _c("el-divider")
                                : _vm._e(),
                              _vm.exibirTabelaParcelas
                                ? _c(
                                    "el-row",
                                    {
                                      staticClass: "mb-20",
                                      attrs: { type: "flex", gutter: 40 }
                                    },
                                    [
                                      _c("el-col", { attrs: { span: 8 } }, [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                staticClass: "full-width",
                                                attrs: {
                                                  data: _vm.parcelasTabela
                                                }
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "parcela",
                                                    label: "Parcela"
                                                  }
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "valor",
                                                    label: "Valor (R$)"
                                                  }
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "dataVencimento",
                                                    label: "Data de vencimento"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _c("div", [
                      _vm.tela === 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "validation-observer",
                                { ref: "validation", attrs: { tag: "form" } },
                                [
                                  _vm.dadosInteressado
                                    ? _c(
                                        "form",
                                        {
                                          on: {
                                            submit: function($event) {
                                              $event.preventDefault()
                                              return _vm.onSubmit($event)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              !_vm.isParcelado
                                                ? _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules: "notZero"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "app-label",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Valor Principal:"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "app-double-input",
                                                                      {
                                                                        staticClass:
                                                                          "input",
                                                                        class: {
                                                                          erro:
                                                                            errors.length
                                                                        },
                                                                        attrs: {
                                                                          prefix:
                                                                            "R$ ",
                                                                          propId:
                                                                            "label-valorPrincipal"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.valorPrincipal,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.valorPrincipal = $$v
                                                                          },
                                                                          expression:
                                                                            "valorPrincipal"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "help erro"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            3325080487
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "Valor Multa:"
                                                    }
                                                  }),
                                                  _c("app-double-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      disable: true,
                                                      prefix: "R$ "
                                                    },
                                                    model: {
                                                      value: _vm.valorMulta,
                                                      callback: function($$v) {
                                                        _vm.valorMulta = $$v
                                                      },
                                                      expression: "valorMulta"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Valor Correção Monetária:"
                                                    }
                                                  }),
                                                  _c("app-double-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      disable: true,
                                                      prefix: "R$ "
                                                    },
                                                    model: {
                                                      value: _vm.valorCorrecao,
                                                      callback: function($$v) {
                                                        _vm.valorCorrecao = $$v
                                                      },
                                                      expression:
                                                        "valorCorrecao"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Valor Acréscimos Monetários:"
                                                    }
                                                  }),
                                                  _c("app-double-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      disable: true,
                                                      prefix: "R$ "
                                                    },
                                                    model: {
                                                      value: _vm.valorAcrescimo,
                                                      callback: function($$v) {
                                                        _vm.valorAcrescimo = $$v
                                                      },
                                                      expression:
                                                        "valorAcrescimo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "Valor Total:"
                                                    }
                                                  }),
                                                  _c("app-double-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value: _vm.total(),
                                                      disable: true,
                                                      prefix: "R$ "
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            {
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Data de Vencimento:"
                                                    }
                                                  }),
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules:
                                                        "required|dateAfterToday"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "el-date-picker",
                                                                {
                                                                  staticClass:
                                                                    "input full-width",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Selecione",
                                                                    "picker-options":
                                                                      _vm.options,
                                                                    format:
                                                                      "dd/MM/yyyy",
                                                                    id:
                                                                      "id-datavencimento"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.dataVencimento,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.dataVencimento = $$v
                                                                    },
                                                                    expression:
                                                                      "dataVencimento"
                                                                  }
                                                                }
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      1322491219
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: { label: "Receita:" }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      disabled: "disabled"
                                                    },
                                                    model: {
                                                      value: _vm.receita,
                                                      callback: function($$v) {
                                                        _vm.receita = $$v
                                                      },
                                                      expression: "receita"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "Data do Cálculo:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value: _vm.dataCalculo,
                                                      "prefix-icon":
                                                        "el-icon-date",
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "Referência:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value: _vm.referencia,
                                                      "prefix-icon":
                                                        "el-icon-date",
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("app-divider", {
                                            staticClass: "mb-20",
                                            attrs: { label: "" }
                                          }),
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Nome/Razão Social:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value:
                                                        _vm.dadosInteressado
                                                          .nomeRazaoSocial,
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label: "CPF/CNPJ:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value:
                                                        _vm.dadosInteressado
                                                          .cpfCnpj,
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Documento de Origem:"
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    staticClass: "input",
                                                    attrs: {
                                                      value:
                                                        _vm.processo
                                                          .numeroProcesso,
                                                      disabled: "disabled"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "flex",
                                                gutter: 40
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Município:"
                                                                }
                                                              }),
                                                              _c(
                                                                "el-select",
                                                                {
                                                                  staticClass:
                                                                    "full-width input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "id-municipio"
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.pegaNomeMunicipio
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.idMunicipio,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.idMunicipio = $$v
                                                                    },
                                                                    expression:
                                                                      "idMunicipio"
                                                                  }
                                                                },
                                                                _vm._l(
                                                                  _vm.municipios,
                                                                  function(
                                                                    municipio
                                                                  ) {
                                                                    return _c(
                                                                      "el-option",
                                                                      {
                                                                        key:
                                                                          municipio.id,
                                                                        attrs: {
                                                                          label:
                                                                            municipio.nome,
                                                                          value:
                                                                            municipio.id
                                                                        }
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm.isVisualizarMunicipio
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "mt-20"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "link",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.utilizarMunicipio()
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Utilizar município do interessado"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      491199706
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Endereço:"
                                                                }
                                                              }),
                                                              _c("el-input", {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  value:
                                                                    _vm.endereco,
                                                                  maxlength:
                                                                    "100",
                                                                  id:
                                                                    "id-endereco"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.endereco,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.endereco = $$v
                                                                  },
                                                                  expression:
                                                                    "endereco"
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm.isVisualizarMunicipio
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "mt-20"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "link",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.utilizarEndereco()
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Utilizar endereço do interessado"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3904222254
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c("app-label", {
                                                                attrs: {
                                                                  label:
                                                                    "Telefone:"
                                                                }
                                                              }),
                                                              _c("el-input", {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  value:
                                                                    _vm.telefone,
                                                                  id:
                                                                    "id-telefone"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.telefone,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.telefone = $$v
                                                                  },
                                                                  expression:
                                                                    "telefone"
                                                                }
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "help erro"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-20"
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "link",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.utilizarTelefone()
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Utilizar telefone do interessado"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      2345734675
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("app-label", {
                                                    attrs: {
                                                      label:
                                                        "Informações Adicionais: ",
                                                      required: false
                                                    }
                                                  }),
                                                  _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: 5,
                                                      placeholder:
                                                        "Digite o texto...",
                                                      maxlength: "500",
                                                      "show-word-limit":
                                                        "show-word-limit"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.informacoesAdicionais,
                                                      callback: function($$v) {
                                                        _vm.informacoesAdicionais = $$v
                                                      },
                                                      expression:
                                                        "informacoesAdicionais"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tela === 2
                        ? _c(
                            "div",
                            [
                              _c("el-divider", [
                                _c("h3", [_vm._v("Dados do documento")])
                              ]),
                              _c(
                                "el-row",
                                { attrs: { gutter: 40 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c("app-display", {
                                        attrs: {
                                          label: "Nome/Razão Social:",
                                          content:
                                            _vm.dadosInteressado.nomeRazaoSocial
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "CPF/CNPJ:",
                                          content: _vm.dadosInteressado.cpfCnpj
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Endereço:",
                                          content: _vm.endereco
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Município:",
                                          content: _vm.municipio
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Telefone:",
                                          content: _vm.telefone
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c("app-display", {
                                        attrs: {
                                          label: "Documento Origem:",
                                          content: _vm.processo.numeroProcesso
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Receita:",
                                          content: _vm.receita
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Referência:",
                                          content: _vm.receita
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Data de Vencimento:",
                                          content: _vm.formatData(
                                            _vm.dataVencimento
                                          )
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Data do Cálculo:",
                                          content: _vm.dataCalculo
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c("app-display", {
                                        attrs: {
                                          label: "Valor Principal:",
                                          content: _vm.formatValor(
                                            _vm.valorPrincipal
                                          )
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Valor Multa:",
                                          content: _vm.formatValor(
                                            _vm.valorMulta
                                          )
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Valor Correção Monetária:",
                                          content: _vm.formatValor(
                                            _vm.valorCorrecao
                                          )
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Valor Acréscimos Monetários:",
                                          content: _vm.formatValor(
                                            _vm.valorAcrescimo
                                          )
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Valor Total:",
                                          content: _vm.formatValor(
                                            _vm.valorTotal
                                          )
                                        }
                                      }),
                                      _c("app-display", {
                                        attrs: {
                                          label: "Informações Adicionais:",
                                          content: _vm.informacoesAdicionais
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                _c("app-buttons-cadastro", {
                  attrs: {
                    isPrimeiroPasso: _vm.isPrimeiroPasso,
                    isUltimoPasso: _vm.tela === 2,
                    showButtonCancelar: _vm.exibirSteps,
                    showButtonProximo: _vm.exibirSteps,
                    isDae: _vm.exibirBotaoVoltarDae
                  },
                  on: {
                    cancelar: _vm.cancelar,
                    proximo: _vm.proximo,
                    voltar: _vm.voltar,
                    finalizar: _vm.finaliza
                  }
                })
              ]
            : _vm._e(),
          _vm.step === 2 && _vm.dadosCadastro
            ? [
                _c(
                  "el-card",
                  { staticClass: "card-collapse", attrs: { shadow: "hover" } },
                  [
                    _c("app-despachos", {
                      attrs: {
                        idProcesso: _vm.idProcesso,
                        data: _vm.dadosCadastro.setores
                      },
                      on: {
                        getDownload: _vm.getDownload,
                        getAnotacao: _vm.getAnotacao
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33250acf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33250acf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/EmitirDae.vue
// module id = null
// module chunks = 